import { camelToDash } from './basler-components.es869.js';
import { renderHTML } from './basler-components.es865.js';
import { camelCaseAttributes } from './basler-components.es871.js';

function renderSVG(element, renderState, _styleProp, projection) {
    renderHTML(element, renderState, undefined, projection);
    for (const key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}

export { renderSVG };
